@import "src/style/lib";
@import "src/components/ProductListItem/style";

.product-select-item {
  .select-box-overlay .select-box-result & {
    @extend .product-list-item;

    .info-col {
      flex: 0 1 calc(100% - 6.5rem);
      max-width: calc(100% - 6.5rem);
      @include media-breakpoint-down("lg") {
        flex: 0 1 calc(100% - 4.5rem);
        max-width: calc(100% - 4.5rem);
      }
      @include media-breakpoint-down("sm") {
        flex: 0 1 calc(100% - 4rem);
        max-width: calc(100% - 4rem);
      }
    }
  }
}
